import React, { useEffect, useMemo, useState } from 'react'
import classNames from 'classnames'

import PaginationV2 from './PaginationV2'
import TmoSelect from '../../tmoForms/TmoSelect'
import style from './PaginationV3.module.css'

function PaginationV3({
  className,
  items,
  itemsPerPage = 6,
  render,
  dynamicPages,
  testId
}) {
  const [selectedPageNumber, setSelectedPageNumber] = useState(1)
  const [dynamicItemsPerPage, setDynamicItemsPerPage] = useState(
    dynamicPages && dynamicPages.length ? dynamicPages[0] : 0
  )

  useEffect(() => setSelectedPageNumber(1), [items])

  const visibleItems = useMemo(() => {
    const startIndex =
      dynamicPages && dynamicPages.length
        ? dynamicItemsPerPage * (selectedPageNumber - 1)
        : itemsPerPage * (selectedPageNumber - 1)
    return items.slice(
      startIndex,
      startIndex +
      (dynamicPages && dynamicPages.length
        ? dynamicItemsPerPage
        : itemsPerPage)
    )
  }, [
    selectedPageNumber,
    items,
    itemsPerPage,
    dynamicItemsPerPage,
    dynamicPages
  ])

  const handlePageSizeChange = (value) => {
    setDynamicItemsPerPage(+value)
    setSelectedPageNumber(1)
  }

  const selectSpecs =
    dynamicPages && dynamicPages.length
      ? {
        options: dynamicPages.map((o) => ({ value: o, text: o }))
      }
      : {}

  const totalPages = useMemo(
    () =>
      dynamicPages && dynamicPages.length
        ? Math.ceil(items.length / dynamicItemsPerPage)
        : Math.ceil(items.length / itemsPerPage),
    [items, itemsPerPage, dynamicItemsPerPage, dynamicPages]
  )

  return (
    <div className={classNames(style.container, className)} data-testid={testId} >
      {render(visibleItems)}
      {totalPages > 1 && (
        <div className={style.paginationWrapper}>
          {dynamicPages && dynamicPages.length && (
            <div className={style.pageSize}>
              <span> Items per page </span>
              <TmoSelect
                defaultValue={dynamicItemsPerPage}
                value={dynamicItemsPerPage}
                selectSpecs={selectSpecs}
                onChange={handlePageSizeChange}
              />
            </div>
          )}
          <div className={style.pagination}>
            <PaginationV2
              totalPages={totalPages}
              onPageChanged={setSelectedPageNumber}
              selectedPageNumber={selectedPageNumber}
            />
          </div>
        </div>
      )}
    </div>
  )
}

export default PaginationV3
